module.exports = __webpack_public_path__ + "static/media/Amatic SC.e9a42e33.ttf";